import axios from 'axios';
import { setFetchingCount } from '../actions/app';
import moment from 'moment-timezone';
import JwtDecode from 'jwt-decode';

var axiosInstance = axios.create({
  baseURL: window.location.origin,
  timeout: 1000000
});

axiosInstance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      //unauthorized
      window.location = '/Login.jsp';
    } else {
      return Promise.reject(error);
    }
  }
);

export { axiosInstance };

/**
 * a thunk action creator
 * @param url
 * @param constName - action to dispatch with data after fetching.
 * @returns {Function}
 */
export function getAjaxRequest(url, constName) {
  return dispatch => {
    return axiosInstance.get(url).then(response => {
      return dispatch({
        type: constName,
        payload: response.data
      });
    });
  };
}

export function dispatchAjaxResponseWithCharger(url, constName) {
  return dispatch => {
    dispatch(setFetchingCount(true));
    return axiosInstance
      .get(url)
      .then(response => {
        return dispatch({
          type: constName,
          payload: response.data
        });
      })
      .finally(() => {
        return dispatch(setFetchingCount(false));
      });
  };
}

export function putAjaxRequest(url, payload, constName) {
  return dispatch => {
    return axiosInstance.put(url, payload).then(response => {
      return dispatch({
        type: constName,
        payload: response.data
      });
    });
  };
}

export function getObjByKey(array, key) {
  for (let i = 0; i < array.length; i++) {
    if (array[i].key === key) {
      return array[i];
    }
  }
  return null;
}

// percent parameter is -1.0 to 1.0
export function shadeColor2(color, percent) {
  var f = parseInt(color.slice(1), 16),
    t = percent < 0 ? 0 : 255,
    p = percent < 0 ? percent * -1 : percent,
    R = f >> 16,
    G = (f >> 8) & 0x00ff,
    B = f & 0x0000ff;
  return (
    '#' +
    (
      0x1000000 +
      (Math.round((t - R) * p) + R) * 0x10000 +
      (Math.round((t - G) * p) + G) * 0x100 +
      (Math.round((t - B) * p) + B)
    )
      .toString(16)
      .slice(1)
  );
}

export function linearGradient(color, dir) {
  let transparent = hexToRgba(color, 0);
  if (color === 'transparent') {
    return `linear-gradient(to ${dir}, rgba(255,0,0,0) 40%, rgba(255,255,255,1) 90%);`;
  } else {
    return `linear-gradient(to ${dir}, rgba(${transparent}) 40%, ${color} 90%);`;
  }
}

export function hexToRgba(hex, opacity) {
  hex = hex.replace(/[^0-9A-F]/gi, '');
  var bigint = parseInt(hex, 16);
  var r = (bigint >> 16) & 255;
  var g = (bigint >> 8) & 255;
  var b = bigint & 255;
  return [r, g, b, opacity].join();
}

export function openWindow(url, name) {
  let windowprops =
    'location=no,menubars=no,toolbars=no,resizable=yes,left=50,top=50,width=1250,height=760';
  if (name === 'chat') {
    windowprops =
      'width=400px,height=660px,toolbar=no,resizable=yes,scrollbars=yes,directories=no,menubar=no,location=no';
  }
  let popupWindow = window.open(url, name, windowprops);
  popupWindow.focus();
}

// to open specific article, call the function with article ID.
// newWinName should be 'FAQfromSSP' to prevent _general.js from adding the 'notAddingIndexJSP' parameter after the #article
export function openFaq(faqId = null, newWinName = 'FAQfromSSP') {
  let windowprops =
    'location=no,menubars=no,toolbars=no,resizable=yes,left=50,top=50,width=1250,height=760';
  let url =
    faqId != null
      ? `/KBFAQTree.jsp?&menuFlag=ssp&notAddingIndexJSP=true#${faqId}`
      : '/KBFAQTree.jsp?menuFlag=ssp&notAddingIndexJSP=true';
  window.open(url, newWinName, windowprops);
}

export function setSessionID() {
  if (!sessionStorage.getItem('sessionStorageID')) {
    let randomText = '';
    let possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 5; i++)
      randomText += possible.charAt(
        Math.floor(Math.random() * possible.length)
      );

    const sessionStorageID = new Date().getTime() + randomText;

    sessionStorage.setItem('sessionStorageID', sessionStorageID);
  }
}

export function reportData(category = '', action = '', label = '') {
  let sessionStorageID = sessionStorage.getItem('sessionStorageID');
  let dataObject = {
    category: category,
    action: action,
    label: label,
    sessionStorageID: sessionStorageID,
    timestamp: moment().format('YYYY-MM-DD HH:mm:ss:SSS'),
    origin: window.location.origin,
    pathname: window.location.pathname
  };
  axios.post(
    'https://data.gateway.sysaid.com/Production/analytics/v1',
    dataObject
  );
}
export function parseQueryString(url) {
  let queryString = {};
  url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function(
    $0,
    $1,
    $2,
    $3
  ) {
    queryString[$1] = $3;
  });
  return queryString;
}
export function getFullDateTimeFormatByCulture(culture) {
  let format = '';
  if (culture == 'american') {
    format = 'MM/DD/YYYY, hh:mm:ss A';
  } else {
    format = 'DD-MM-YYYY HH:mm:ss';
  }
  return format;
}
export function getUnixTimestamp(dt) {
  return new Date(dt).getTime() / 1000;
}

export function getFullDateFormatByCulture(culture) {
  let format = '';
  if (culture == 'american') {
    format = 'MM/DD/YYYY';
  } else {
    format = 'DD-MM-YYYY';
  }
  return format;
}

export function getMaskByDateFormat(culture) {
  let mask = '';
  if (culture == 'american') {
    mask = '99/99/9999';
  } else {
    mask = '99-99-9999';
  }
  return mask;
}

export function getFirstDayOfWeek(day) {
  let locale = '';
  if (day == 'sunday') {
    locale = 'en-us';
  } else {
    locale = 'en-gb';
  }
  return locale;
}

export function formatTimestamp(timeStamp, format) {
  return moment.unix(getUnixTimestamp(timeStamp)).format(format);
}

/**
 * returns the index of the given object in the
 * given objects array, -1 if not contained
 * only needed for cyclic logic
 */
export function getIndex(objects, obj) {
  var i;
  for (i = 0; i < objects.length; i++) {
    if (objects[i] === obj) {
      return i;
    }
  }
  return -1;
}

/**
 * Add two string time values (HH:mm:ss) with javascript
 *
 * Usage:
 *  > addTimes('04:20:10', '21:15:10');
 *  > "25:35:20"
 *  > addTimes('04:35:10', '21:35:10');
 *  > "26:10:20"
 *  > addTimes('30:59', '17:10');
 *  > "48:09:00"
 *
 * @param {String} startTime  String time format
 * @param {String} endTime  String time format
 * @returns {String}
 */
export function calculateTimeRange(startTime, endTime) {
  let times = [0, 0, 0];
  let max = times.length;

  let a = (startTime || '').split(':');
  let b = (endTime || '').split(':');

  // normalize time values
  for (let i = 0; i < max; i++) {
    a[i] = isNaN(parseInt(a[i])) ? 0 : parseInt(a[i]);
    b[i] = isNaN(parseInt(b[i])) ? 0 : parseInt(b[i]);
  }

  // store time values
  for (let i = 0; i < max; i++) {
    times[i] = a[i] + b[i];
  }

  let hours = times[0];
  let minutes = times[1];
  let seconds = times[2];

  if (seconds > 60) {
    let m = (seconds / 60) << 0;
    minutes += m;
    seconds -= 60 * m;
  }

  if (minutes > 60) {
    let h = (minutes / 60) << 0;
    hours += h;
    minutes -= 60 * h;
  }

  return (
    '0' +
    hours +
    ':' +
    ('0' + minutes).slice(-2) +
    ':' +
    ('0' + seconds).slice(-2)
  );
}

/**
 * Converts the RGB color space into YIQ (https://en.wikipedia.org/wiki/YIQ),
 * @param {String} background-color in HEX value
 * @returns {String} white or black text-color
 */

export function getContrastWhiteBlack(hexcolor) {
  if (hexcolor) {
    var hex = hexcolor.replace('#', '');
    var r = parseInt(hex.substr(0, 2), 16);
    var g = parseInt(hex.substr(2, 2), 16);
    var b = parseInt(hex.substr(4, 2), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? '#000000' : '#ffffff';
  } else {
    return '#ffffff';
  }
}

export function refreshToken() {
  if (localStorage.getItem('v2t')) {
    let token = localStorage.getItem('v2t');
    let expirationTime = JwtDecode(token).exp;
    let currentTime = Math.round(new Date().getTime() / 1000);
    if (currentTime > expirationTime) {
      // console.log('token expired');
    } else {
      // console.log('token still valid');
      axiosInstance
        .post(
          'https://2b55eecxwj.execute-api.eu-central-1.amazonaws.com/prod/token/refresh',
          {},
          { headers: { Authorization: token } }
        )
        .then(response => {
          // console.log('response',response);
          if (
            response.data.refreshToken &&
            response.data.refreshToken.length > 0
          ) {
            window.localStorage.setItem('v2t', response.data.refreshToken);
            postToBot();
          }
        })
        .catch(error => {
          // console.log('error',error.response)
        });
    }
  }
}

export function postToBot() {
  let receiver = document.getElementById('receiver').contentWindow;
  // Send a message to the receiver window.
  receiver.postMessage(
    {
      v2t: localStorage.getItem('v2t'),
      url: window.location.origin
    },
    'https://sysaid-chatbot.sysaidit.com'
  );
}



// WEBPACK FOOTER //
// ./utils/helpers.js